import strings from '../../../Localization/Localization';

let name = {
  fieldKey: "name",
  type: "text",
  label: strings.form.phonePriceList.name.label,
  showOnDisabled: () => false,
  validators: []
}

export const form = {
  formKey: "phonePriceListSearch",
  fields: [
    name
  ]
}
